import(/* webpackMode: "eager" */ "/app/src/components/pages/tours/Client.tsx")